/**
 * Valida el rango horario de un tramo (slot) de cierre.
 *
 * Un fin igual o anterior al inicio (p. ej. "00:00") se interpreta como
 * medianoche del día siguiente (24:00), replicando el wrap +1440 /
 * `fixMidnightIssue()` que ya aplica el backend en la generación de cierres.
 *
 * @param ini Hora de inicio en formato "HH:mm".
 * @param end Hora de fin en formato "HH:mm".
 * @returns `true` si el rango es válido (inicio estrictamente anterior al fin).
 */
export function isSlotTimeRangeValid(ini: string, end: string): boolean {
    const [iniH = 0, iniM = 0] = ini.split(':').map(Number);
    const [endH = 0, endM = 0] = end.split(':').map(Number);

    const iniMinutes = iniH * 60 + iniM;
    let endMinutes = endH * 60 + endM;

    // El rango cruza medianoche: el fin pertenece al día siguiente.
    if (iniMinutes > endMinutes) {
        endMinutes += 24 * 60;
    }

    return iniMinutes < endMinutes;
}
